'use strict';

module.exports = string => {

    const burger = document.querySelector('.header__menu-burger');
    const menu = document.querySelector('.header__menu-wrapper-sticky .header__menu-s');
    const menuItems = document.querySelectorAll('.header__menu-wrapper-sticky .header__menu-s .menu-item');
    const headerWrapper = document.querySelector('.header__menu-wrapper-sticky');

    if (!burger) return;


    const handleBurgerVisibility = () => {

        if (window.innerWidth <= 1024) {

            burger.classList.add('show');
            headerWrapper.classList.add('active');

        } else {

            if (window.scrollY > 500) {

                burger.classList.add('show');
                headerWrapper.classList.add('active');

            } else {

                burger.classList.remove('show');
                burger.classList.remove('active');

                headerWrapper.classList.remove('active');
                menu.classList.remove('active');

            }

        }

    };


    window.addEventListener('scroll', handleBurgerVisibility);
    window.addEventListener('resize', handleBurgerVisibility);

    handleBurgerVisibility();

    menuItems.forEach(element => {
        element.addEventListener('click', () => {
            burger.classList.remove('active');
            menu.classList.remove('active');
        })
    });

    burger.addEventListener('click', () => {

        burger.classList.toggle('active');

        menu.classList.toggle('active');

    });


};